import { Box, Typography } from "@mui/material";

const NotfoundPage = () => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#004a613a",
            }}
        >
            <Typography component={"h1"} sx={{ fontSize: "10rem", fontWeight: 600, lineHeight: "10rem" }}>
                404
            </Typography>
            <Typography component={"h2"} sx={{ fontSize: "2rem", fontWeight: 500 }}>
                Not found
            </Typography>
        </Box>
    );
};

export default NotfoundPage;
